/* eslint-disable import/no-unresolved */
/* eslint-disable import/extensions */
import 'js/secure/MsaMigration';
